import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Team } from './team.model';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TeamService {

    constructor(private _httpClient: HttpClient) { }


    getTeam(id: number): Observable<Team>{
        return this._httpClient.get<Team>('/ypm/api/fm/team/' + id);
    }

    guardarTeam(team: Team): Observable<Team>{
        return this._httpClient.post<Team>('/ypm/api/fm/team', team);
    }

}
